import { Link } from "react-router-dom";
import { Button, Icon } from "semantic-ui-react";

const CampaignButtonLink = ({ campaignId, t }) => {
  return (
    <Button
      basic
      className="bmo-purple"
      as={Link}
      to={`/deliveries/${campaignId}`}
      title={t("to_campaign_page")}
      style={{ padding: "0.68571429em 1.5em", height: "36px" }}
      data-test="campaign_button_link"
    >
      <Icon name="linkify" />
      {t("to_campaign_page")}
    </Button>
  );
};
export default CampaignButtonLink;
